import React from 'react';

const AdminDashboard = () => {
  return (
    <div className="admin-dashboard">
      <div className="container">
        <h1>Admin Dashboard</h1>
        <p>Content management system for administrators.</p>
      </div>
    </div>
  );
};

export default AdminDashboard;